import React from 'react';

function Hero({ scrollToSection }) {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-badge">Trusted by 500+ Businesses Worldwide</div>
        <h1 className="hero-title">
          <span className="title-top">Transform Your Business With</span>
          <span className="gradient-text title-main">Stunning Websites or Mobile Apps</span>
          <span className="title-bottom">That Actually Generate Sales</span>
        </h1>
        <p className="hero-description">
          Get a <strong>high-converting website or mobile app</strong> designed by experts. 
          Beautiful designs, lightning-fast performance, and SEO-optimized. 
        </p>
        <p className="hero-description-next">
          <span className="highlight-text">From $499</span> • 
          <span className="highlight-text">Quick Turnaround Time</span> • 
          <span className="highlight-text">100% Guaranteed</span>
        </p>
        <div className="hero-cta">
          <button 
            className="btn-large btn-primary"
            onClick={() => scrollToSection('contact')}
          >
            Get Free Consultation →
          </button>
          <button 
            className="btn-large btn-outline"
            onClick={() => scrollToSection('services')}
          >
            View Our Work
          </button>
        </div>
        <div className="hero-trust">
          <span className="trust-badge">⚡ Fast Delivery</span>
          <span className="trust-badge">📞 Free Support</span>
        </div>
        <div className="hero-metrics">
          <div className="metric">
            <div className="metric-value">500+</div>
            <div className="metric-label">Projects Delivered</div>
          </div>
          <div className="metric">
            <div className="metric-value">200+</div>
            <div className="metric-label">Happy Clients</div>
          </div>
          <div className="metric">
            <div className="metric-value">10+</div>
            <div className="metric-label">Years In Business</div>
          </div>
          <div className="metric">
            <div className="metric-value">4.9/5</div>
            <div className="metric-label">Client Rating</div>
          </div>
        </div>
      </div>
      <div className="hero-visual">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="grid-pattern"></div>
      </div>
    </section>
  );
}

export default Hero;
